module.exports = __webpack_public_path__ + "static/media/hillshade.vertex.03ee1f4b.glsl";